"use client";

import { useEffect } from "react";
import { subscribeToChunkErrors } from "./chunkReload";

/**
 * Recovers from stale-deploy chunk failures that fire outside React's render
 * path — router prefetches and rejected `import()` promises never reach the
 * `global-error` boundary, so we listen at the window level too. When a deploy
 * replaces a lazily-loaded route chunk, a client with the old build open 404s
 * on the old hash ("Loading chunk NNN failed"); a one-time hard reload fetches
 * the fresh HTML with the current hashes. Listener wiring lives in
 * `subscribeToChunkErrors` so it can be unit-tested with a fake window.
 */
export function ChunkErrorReloader() {
  useEffect(() => subscribeToChunkErrors(window), []);
  return null;
}
